import { SynthetixMarketProxy } from './abi/SynthetixMarketProxy';
import { scWalletAave } from './abi/scWalletAave';
import { scWalletAccountResolver } from './abi/scWalletAccountResolver';
import { scWalletAuth } from './abi/scWalletAuth';
import { scWalletBasic } from './abi/scWalletBasic';
import { scWalletFlashPoolConnector } from './abi/scWalletFlashPoolConnector';
import { scWalletIndex } from './abi/scWalletIndex';
import { scWalletMainImpl } from './abi/scWalletMainImpl';
import { scWalletMatcha } from './abi/scWalletMatcha';
import { scWalletSynthetixPerpV2 } from './abi/scWalletSynthetixPerpV2';
import { scWalletSynthetixPerpV2AdvancedOrder } from './abi/scWalletSynthetixPerpV2AdvancedOrder';
import { scWalletSynthetixPerpV2LimitOrder } from './abi/scWalletSynthetixPerpV2LimitOrder';
import { FxNftAbi } from './abi/fxNft';

const abi = {
	scWalletIndex,
	scWalletAccountResolver,
	scWalletMainImpl,
	scWalletSynthetixPerpV2,
	scWalletBasic,
	scWalletSynthetixPerpV2LimitOrder,
	scWalletSynthetixPerpV2AdvancedOrder,
	SynthetixMarketProxy,
	scWalletMatcha,
	scWalletAuth,
	scWalletAave,
	scWalletFlashPoolConnector,
	FxNftAbi
};

export default abi;
